import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const accEntryOper = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] OPER',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.oper(params.action, params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const accEntryOperAuth = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] OPER_AUTH',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.oper('auth', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const accEntryOperSortDown = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] OPER_SORT_DOWN',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.oper('sortdown', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const accEntryOperSortUp = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] OPER_SORT_UP',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.oper('sortup', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const accEntryOperUnAuth = createAsyncThunk<any, Record<string, any>, ThunkApi>(
  '[ACC_ENTRY] OPER_UN_AUTH',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.accEntry.oper('unauth', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)
